import { Box, Text, Radio, RadioGroup, VStack, Flex } from '@chakra-ui/react';

const SurveyQuestion = ({ selectedOption, setSelectedOption }) => {
  const handleBoxClick = (option) => {
    setSelectedOption(option);
  };

  return (
    <Box textAlign="center">
     
      {/* Centered Radio Buttons with Highlighted Selection */}
      <RadioGroup onChange={setSelectedOption} value={selectedOption} mt={4}>
        <VStack spacing={3} align="center"> {/* Stack items vertically and center them */}
          {[
            "Content creation",
            "Digital Marketing",
            "Technology development",
            "Tutoring/education",
            "Administrative/virtual assistance"
          ].map((option) => (
            <Box
              key={option}
              w="80%" maxW="800px"
              p={4}
              bg={selectedOption === option ? "#13BD95" : "#D9D9D9"} // Change color when selected
              borderRadius="md"
              transition="background-color 0.3s ease"
              _hover={{ bg: selectedOption === option ? "#13BD95" : "#BFBFBF" }} // Lighten on hover
              onClick={() => handleBoxClick(option)} // Make the whole box clickable
              cursor="pointer" // Add pointer cursor for better UX
            >
              <Flex align="center">
                <Radio 
                  value={option} 
                  colorScheme="white" // Use predefined color
                  mr={3} 
                  sx={{
                    '[data-checked] &': { 
                      borderColor: "#13BD95", // Custom checked color
                    }
                  }}
                  isDisabled // Disable the radio button so it doesn't interfere with the clickable box
                />
                <Text color={selectedOption === option ? "white" : "black"}>
                  {option}
                </Text>
              </Flex>
            </Box>
          ))}
        </VStack>
      </RadioGroup>
    </Box>
  );
};

export default SurveyQuestion;
